export const initialVendorState = {
    vendors: [],
    vendor: null,
    status: 'idle',
    error: null,
  };
  